var LocalStorageWorker = /** @class */ (function () {
    function LocalStorageWorker() {
    }
    LocalStorageWorker.setItem = function (key, value) {
        return typeof localStorage !== 'undefined' &&
            localStorage.setItem(key, JSON.stringify(value));
    };
    LocalStorageWorker.getItem = function (key) {
        if (typeof localStorage === 'undefined') {
            return 'empty';
        }
        var storageValue = localStorage.getItem(key);
        if (storageValue) {
            try {
                var result = JSON.parse(storageValue);
                return result;
            }
            catch (_a) {
                return null;
            }
        }
        return storageValue;
    };
    return LocalStorageWorker;
}());
export { LocalStorageWorker };
